export const localDevelopmentOrigin = "techture.staging.cube.ms"
export const localDevelopmentSubdomain = localDevelopmentOrigin.split('.').slice(1).join("")